import CoursePromotionPage from '@/pages/landings/CoursePromotionPage.vue';
import CoursePromotionLessons from '@/pages/landings/CoursePromotionLessons.vue';
import { PROMOTION_COURSE_LANDINGS, PROMOTION_LANDINGS } from '@/constants/landings';

const COURSE_PROMOTION_ROUTES = [
  {
    path: '/c/how-to-make-money-online',
    name: 'HowToMakeMoneyOnline',
    component: CoursePromotionPage,
    props: {
      sections: PROMOTION_LANDINGS['how-to-make-money-online'],
    },
  },
  {
    path: '/c/how-to-make-money-online-content-creator',
    name: 'HowToMakeMoneyOnlineContentCreator',
    component: CoursePromotionPage,
    props: {
      sections: PROMOTION_LANDINGS['how-to-make-money-online-content-creator'],
    },
  },
  {
    path: '/c/how-to-make-money-online-course',
    name: 'HowToMakeMoneyOnlineCourse',
    component: CoursePromotionLessons,
    props: {
      course: PROMOTION_COURSE_LANDINGS['how-to-make-money-online-course'],
    },
  },
  {
    path: '/c/overcoming-starter-block',
    name: 'OvercomingStarterBlock',
    component: CoursePromotionPage,
    props: {
      sections: PROMOTION_LANDINGS['overcoming-starter-block'],
    },
  },
  {
    path: '/c/overcoming-starter-block-content-creator',
    name: 'OvercomingStarterBlockContentCreator',
    component: CoursePromotionPage,
    props: {
      sections: PROMOTION_LANDINGS['overcoming-starter-block-content-creator'],
    },
  },
  {
    path: '/c/overcoming-starter-block-online-course',
    name: 'OvercomingStarterBlockOnlineCourse',
    component: CoursePromotionLessons,
    props: {
      course: PROMOTION_COURSE_LANDINGS['overcoming-starter-block-online-course'],
    },
  },
  {
    path: '/c/trackling-imposter-syndrome',
    name: 'TracklingImposterSyndrome',
    component: CoursePromotionPage,
    props: {
      sections: PROMOTION_LANDINGS['trackling-imposter-syndrome'],
    },
  },
  {
    path: '/c/trackling-imposter-syndrome-content-creator',
    name: 'TracklingImposterSyndromeContentCreator',
    component: CoursePromotionPage,
    props: {
      sections: PROMOTION_LANDINGS['trackling-imposter-syndrome-content-creator'],
    },
  },
  {
    path: '/c/trackling-imposter-syndrome-online-course',
    name: 'TracklingImposterSyndromeOnlineCourse',
    component: CoursePromotionLessons,
    props: {
      course: PROMOTION_COURSE_LANDINGS['trackling-imposter-syndrome-online-course'],
    },
  },
  {
    path: '/c/start-thinking-like-an-entrepreneur',
    name: 'startThinkingLikeAnEntrepreneur',
    component: CoursePromotionPage,
    props: {
      sections: PROMOTION_LANDINGS['start-thinking-like-an-entrepreneur'],
    },
  },
  {
    path: '/c/start-thinking-like-an-entrepreneur-content-creator',
    name: 'startThinkingLikeAnEntrepreneurContentCreator',
    component: CoursePromotionPage,
    props: {
      sections: PROMOTION_LANDINGS['start-thinking-like-an-entrepreneur-content-creator'],
    },
  },
  {
    path: '/c/start-thinking-like-an-entrepreneur-online-course',
    name: 'startThinkingLikeAnEntrepreneurOnlineCourse',
    component: CoursePromotionLessons,
    props: {
      course: PROMOTION_COURSE_LANDINGS['start-thinking-like-an-entrepreneur-online-course'],
    },
  },
  {
    path: '/c/100-true-fans',
    name: '100TrueFans',
    component: CoursePromotionPage,
    props: {
      sections: PROMOTION_LANDINGS['100-true-fans'],
    },
  },
  {
    path: '/c/100-true-fans-content-creator',
    name: '100TrueFansContentCreator',
    component: CoursePromotionPage,
    props: {
      sections: PROMOTION_LANDINGS['100-true-fans-content-creator'],
    },
  },
  {
    path: '/c/100-true-fans-online-course',
    name: '100TrueFansOnlineCourse',
    component: CoursePromotionLessons,
    props: {
      course: PROMOTION_COURSE_LANDINGS['100-true-fans-online-course'],
    },
  },
];

export default COURSE_PROMOTION_ROUTES;
